// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__9YEYV","background":"Modal_background__KOGep","inner":"Modal_inner__+SHid"};